<template>
  <nav class="main-nav" :class="{ inverted, hidden: isCover }">
    <div class="nav-wrapper">
      <span class="section-title" :class="{ hidden: !subsection }">
        {{ title }}
        <span class="section-subtitle tx-wg-regular">{{ subtitle }}</span>
      </span>
      <ul>
        <router-link to="/about" v-slot="{ href, navigate, isActive, isExactActive }">
          <li
            class="section"
            :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
          >
            <a :href="href" @click="navigate">01</a>
          </li>
        </router-link>
        <router-link to="/value" v-slot="{ href, navigate, isActive, isExactActive }">
          <li
            class="section"
            :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
          >
            <a :href="href" @click="navigate">02</a>
            <ul>
              <li class="subsection"><router-link to="/value/projects"></router-link></li>
              <li class="subsection"><router-link to="/value/research"></router-link></li>
              <li class="subsection"><router-link to="/value/solidarity"></router-link></li>
            </ul>
          </li>
        </router-link>
        <router-link to="/credits" v-slot="{ href, navigate, isActive, isExactActive }">
          <li
            class="section"
            :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
          >
            <a :href="href" @click="navigate">03</a>
          </li>
        </router-link>
      </ul>
    </div>
    <a
      class="download"
      :href="attachment.file.path[$i18n.locale]"
      :class="{ hidden: !subsection }"
      target="_blank"
      download
    >
      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect x="1.623" y="1.586" width="28.5" height="28.5" rx="14.25"/><path d="M20.748 12.665l-4.875 4.875-4.875-4.874M15.873 7.078v10.265"/><path d="M9.37 16.706v5.306h13.003v-5.306"/></svg>
    </a>
  </nav>
</template>

<script>
import attachments from '@/assets/data/attachments';
export default {
  data() {
    return {
      attachment: attachments['previous-editions'][0]
    };
  },
  computed: {
    meta() {
      let meta = {};
      for (let i = 0; i < this.$route.matched.length; i++) {
        meta = { ...meta, ...this.$route.matched[i].meta };
      }
      return meta;
    },
    isCover() {
      return this.$route.name === 'cover';
    },
    title() {
      if (this.meta.title) return this.$t(this.meta.title);
      return '';
    },
    subtitle() {
      if (this.meta.subtitle) return this.$t(this.meta.subtitle);
      return '';
    },
    subsection() {
      return this.$route.matched.length > 2;
    },
    inverted() {
      return this.$route.meta.inverted;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-nav {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: opacity 0.3s;
  z-index: 1001;
  pointer-events: none;
  .nav-wrapper {
    pointer-events: all;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
  }
  &.inverted {
    a,
    .section-title {
      color: $col-navy-dark;
    }
  }
  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
  .section-title {
    display: block;
    writing-mode: vertical-lr;
    text-orientation: sideways;
    transform: rotate(180deg);
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 1rem;
    transition: max-height 0.3s;
    max-height: 450px;
    white-space: nowrap;
    overflow: hidden;
    &.hidden {
      padding-bottom: -0.1rem;
      max-height: 0;
    }
  }
  li {
    pointer-events: all;
    margin-bottom: 0.5rem;
    &.section {
      margin-bottom: 1.3rem;
    }
    & > a {
      text-align: right;
      display: block;
      width: 2.4rem;
      transition: color 0.3s;
      &:hover {
        text-decoration: none;
        opacity: 0.9;
      }
    }
    &.section {
      transition: border 0.3s;
      &.router-link-active > a {
        font-weight: bold;
        border-left: 5px solid currentColor;
      }
    }
    &.subsection {
      & > a {
        height: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        &:after {
          content: '';
          display: inline-block;
          width: 1rem;
          height: 1px;
          background-color: currentColor;
          transition: height 0.3s;
          transform-origin: center;
        }
        &.router-link-active:after {
          height: 4px;
        }
      }
    }
  }
  .download {
    position: fixed;
    padding: $padding / 4;
    padding-bottom: $padding;
    left: 0;
    bottom: 0;
    pointer-events: all;
    transition: opacity 0.3s;
    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
    svg {
      stroke: currentColor;
      transform: scale(1.2, 1.2);
    }
  }
}
</style>
